var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M75.63,0H10.37C4.65,0,0,5.07,0,11.29V50C0,56.22,4.65,61.3,10.37,61.3H75.63C81.35,61.3,86,56.22,86,50V11.29C86,5.07,81.35,0,75.63,0Zm3.53,50a3.75,3.75,0,0,1-3.53,4H10.37a3.75,3.75,0,0,1-3.53-4c0-11.19,0-30.93.08-37.46L40.75,39a3.34,3.34,0,0,0,4.5,0L79.08,12.51C79.11,19,79.15,38.78,79.16,50Zm-67-42.45c6,0,19.62-.08,30.88-.08s24.93,0,30.88.07L43,31.36Z","fill":"#2a2d58","key":1})]);
}

Mail.defaultProps = {"viewBox":"0 0 86 61.3"};

module.exports = Mail;

Mail.default = Mail;
